export default __webpack_public_path__ + "static/media/SBLogo.5f7cb6f5.png";